import api from "../api";

const api_type = 'v1'

export const GetProductCheck = params => { return api.post(api_type+`/product/check`, params) }




// WEBPACK FOOTER //
// ./src/api/v1/product_api.js